import { Badge } from '@wartek-id/badge'
import { Text } from '@wartek-id/text-v1'

import { useApiGetPendingPerencanaan } from 'api/kinerja/kepala-sekolah/pengawas-sekolah/perencanaan'
import { Header } from 'app/KinerjaShared/components/Header'
import {
  TableBody,
  TableHeader,
  TableHeaderItem,
  TablePelaksanaanKinerja,
  TableShimmer,
  TableRow,
  TableRowItem,
} from 'app/KinerjaShared/components/TablePelaksanaanKinerja'
import TableRowStates from 'app/KinerjaShared/components/TableRowStates'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

import type { FC } from 'react'

type PerencanaanProps = {}

const Perencanaan: FC<PerencanaanProps> = ({}) => {
  const { isEnabled, isHavePeriod } = usePeriodContext()

  const { isLoading, isError, data, refetch } = useApiGetPendingPerencanaan(
    {},
    { enabled: isEnabled && isHavePeriod }
  )

  const hasData = data?.data?.length > 0

  return (
    <>
      <Header
        title="Perencanaan Kinerja Kepala Sekolah"
        className="mb-9 print:hidden"
      />

      <section className="bg-white border border-subdued rounded-lg mt-6">
        <div className="p-6">
          <Text variant="heading-md">Daftar Kepala Sekolah</Text>
        </div>

        <TablePelaksanaanKinerja className="mt-0">
          <TableHeader>
            <TableHeaderItem className="w-1/5">
              <Text variant="body" color="default" className="!font-bold">
                Nama
              </Text>
            </TableHeaderItem>
            <TableHeaderItem className="w-1/5 pl-0">
              <Text variant="body" color="default" className="!font-bold">
                Jabatan
              </Text>
            </TableHeaderItem>
            <TableHeaderItem className="w-1/5 pl-0">
              <Text variant="body" color="default" className="!font-bold">
                Satuan Pendidikan
              </Text>
            </TableHeaderItem>
            <TableHeaderItem className="w-1/5 pl-0">
              <Text variant="body" color="default" className="!font-bold">
                Status
              </Text>
            </TableHeaderItem>
            <TableHeaderItem className="w-1/5 pl-0" />
          </TableHeader>
          <TableBody>
            {/* If loading */}
            {isLoading && <TableShimmer columns={5} />}

            {/* If error or no data returned */}
            {!isLoading && (isError || !hasData) && (
              <TableRowStates
                type={isError ? 'ERROR' : 'EMPTY'}
                onClick={() => {
                  refetch()
                }}
              >
                Jika ada Pegawai dengan Perencanaan Kinerja yang belum
                <br />
                dikumpulkan, datanya akan tampil di sini.
              </TableRowStates>
            )}

            {/* If data returned */}
            {hasData && (
              <>
                {data?.data?.map((item, index) => (
                  <>
                    <TableRow key={`perencanaan-${index}`}>
                      <TableRowItem className="align-middle">
                        <Text
                          variant="body-sm"
                          color="default"
                          className="overflow-wrap-anywhere"
                        >
                          {item?.nama}
                        </Text>
                      </TableRowItem>
                      <TableRowItem className="align-middle pl-0">
                        <Text
                          variant="body-sm"
                          color="default"
                          className="overflow-wrap-anywhere"
                        >
                          {item?.jabatan}
                        </Text>
                      </TableRowItem>
                      <TableRowItem className="align-middle pl-0">
                        <Text
                          variant="body-sm"
                          color="default"
                          className="overflow-wrap-anywhere"
                        >
                          {item?.satuanPendidikan}
                        </Text>
                      </TableRowItem>
                      <TableRowItem className="align-middle pl-0">
                        <Badge variant="critical">Belum dikumpulkan</Badge>
                      </TableRowItem>
                      <TableRowItem />
                    </TableRow>
                  </>
                ))}
              </>
            )}
          </TableBody>
        </TablePelaksanaanKinerja>
      </section>
    </>
  )
}
export default Perencanaan
